// extracted by mini-css-extract-plugin
module.exports = {"container":"packages-core-App-PromptGDPR-style__container--3yh7-","bottom":"packages-core-App-PromptGDPR-style__bottom--2e4ZQ"};